import { render, staticRenderFns } from "./MaterialPreviewerRow.vue?vue&type=template&id=454f4e53&scoped=true&"
import script from "./MaterialPreviewerRow.vue?vue&type=script&lang=js&"
export * from "./MaterialPreviewerRow.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPreviewerRow.vue?vue&type=style&index=0&id=454f4e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f4e53",
  null
  
)

export default component.exports